import React from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import Tile, { TileProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content/tile';

interface Props {
  data: TileProps;
}

const TileTastic = ({ data }: Props) => {
  return (
    <Tile
      image={data.image}
      title={data.title}
      subtitle={data.subtitle}
      ctaLabel={data.ctaLabel}
      ctaReference={data.ctaReference}
      ctaClassName={CHIPOTLE_CONTENT_LOOK.tileCtaClassName}
    />
  );
};

export default TileTastic;
